var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-center"},[_c('a',{attrs:{"href":'/device/request-devices/' + this.params.value}},[_vm._v(_vm._s(this.params.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }